const { emailRegex } = require("./regexes");

module.exports = (email) => emailRegex.test(email);
